import { useState } from "react";
import Users from "../Components/Users/Users";
import Testimonials from "../Components/Testimonials/Testimonials";
import Transactions from "../Components/Transactions/Transactions";
import Support from "../Components/Support/Support";
import Start from "../Components/Start/Start";
import Hero2 from "../Components/Hero/Hero2";
import Footer from "../Components/Footer/Footer";

import LoadingScreen from "../Components/Loading/LoadingScreen";
import google from "../Assets/Logo/google.svg";
import github from "../Assets/Logo/github.svg";
import { useEffect } from "react";
import { signOut, getRedirectResult, GoogleAuthProvider, GithubAuthProvider} from 'firebase/auth';
import {githubSignIn, googleSignIn, authentication, githubAuthentication, googleSignIn_verification} from '../Config/Signup_op';

const Home = () => {
  // eslint-disable-next-line

  const getLoading = () => {
    let loading = localStorage.getItem('loading');
    if (loading === null){
      return false;
    }
    else{
      return JSON.parse(loading).value;
    }
  }

  const handleLoading = (value) => {
    localStorage.setItem('loading',JSON.stringify({'value':value})); 
  }  

  const [loading, setLoading] = useState(getLoading());

  useEffect(() => {
    let g_value = localStorage.getItem('google_sign_in');
    let t_value = localStorage.getItem('github_sign_in');
    
    console.log(g_value, t_value);
    let authentication_value = authentication().auth; 

    if (t_value === "1"){
      authentication_value = githubAuthentication().auth;
    }

    //signup_handleLoading(value); 
    getRedirectResult(authentication_value)
    .then((result) => {
    // This gives you a Google Access Token. You can use it to access Google APIs.
   
    if (result !== null){
     
      if (g_value === "1"){
        
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.idToken; //.accessToken;
      const displayName = result.user.displayName;
      const photoURL = result.user.photoURL;
      console.log(credential);
      
       googleSignIn_verification(token, photoURL, displayName).then((resp)=>{
          
            if (resp.statusCode === 200){
              
              signOut(authentication_value);
                            
              handleLoading(false);  
              setLoading(false);  
            }else{
              handleLoading(false);
              setLoading(false); 
            }
        }).catch((error) => {
          console.log('Error happened');
          handleLoading(false);
          setLoading(false);
        }); 
      }
      if(t_value === "1"){
        console.log('Here Github');
        const credential = GithubAuthProvider.credentialFromResult(result);
        console.log(credential);
        handleLoading(false);
        setLoading(false);
        // console.log(result.user);
        // console.log(credential.accessToken);
        authentication_value.currentUser.getIdToken(true).then((idToken)=>{
          console.log('the id token',idToken);
        });
      // const token = credential.idToken; //.accessToken;
      // const displayName = result.user.displayName;
      // const photoURL = result.user.photoURL;
      // console.log(token, photoURL, displayName);
      //  googleSignIn_verification(token, photoURL, displayName).then((resp)=>{
      //     console.log(result);
      //       if (resp === 200){
      //        navigate('onboarding',{replace: true});
      //         signOut(authentication().auth);

      //       }
      //   });     
      }       
         

    }
     localStorage.removeItem('github_sign_in');   
    localStorage.removeItem('google_sign_in');   
    
   
    
  }).catch((error) => {
    // Handle Errors here.
   console.log(error);
   handleLoading(false);
  setLoading(false);
  });
},[]);

  const googleSign = () => {
    handleLoading(true);
    localStorage.setItem('google_sign_in',1);        
    googleSignIn();
  };

  const githubSign = () => {
    handleLoading(true); 
    localStorage.setItem('github_sign_in',1);      
    githubSignIn();
  };

  const logins = [
    { image: google, function: googleSign },
    { image: github, function: githubSign },
  ];


  return (
    <>
      {loading ? (
        <LoadingScreen value={loading} />
      ) : (
        <div>
          <Hero2 logins={logins} />
          <Users />
          <Testimonials />
          <Transactions />
          <Support />
          <Start />
          <Footer />
        </div>
      )}
    </>
  );
};

export default Home;
